<template>
  <div class="footer">
    <div class="footer-wrapper">
      <div class="footer-main">
        <div class="footer-main--left">
          <div class="logo"></div>
          <div class="brand-text">JODI GROUP, INC.</div>
          <div>2131 19th Avenue, San Francisco, CA 94116</div>
          <div class="contact">
            <span>
              <a href="http://facebook.com/jodigroup" target="_blank">
                <font-icon class="s-icon" id="facebook"></font-icon>
              </a>
            </span>
            <span>
              <a href="http://twitter.com/jodigroup" target="_blank">
                <font-icon class="s-icon" id="twitter"></font-icon>
              </a>
            </span>
            <span>
              <a href="http://instagram.com/jodigroup" target="_blank">
                <font-icon class="s-icon" id="ins"></font-icon>
              </a>
            </span>
            <span>
              <a href="mailto:admin@jodigroup.com">admin@jodigroup.com</a>
            </span>
            <span>
              TEL:
              <a href="tel:415-661-3232">415-661-3232</a>
            </span>
            <span>FAX: 415-661-3233</span>
          </div>
        </div>
        <div class="footer-main--right">
          <div class="intro-text">More</div>
          <div>
            <a href="/jobs">Join us</a>
          </div>
          <div>
            <a href="/sell/listing">Selling property list</a>
          </div>
          <div>
            <a href="/rent/listing">Rent property list</a>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="footer-bottom--left">
          <span>All Rights Reserved. © 2019-2020 JODI Group, Inc. DRE #01877625.</span>
        </div>
        <div class="footer-bottom--right">
          <a
            href="javascript:;"
            :class="{ 'is-active': currentApiLang === 'zh-CN' }"
            @click="setLang('zh')"
          >简体中文</a>
          <a
            href="javascript:;"
            :class="{ 'is-active': currentApiLang === 'en-US' }"
            @click="setLang('en')"
          >English</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { setup } from '@/lang'

export default {
  data () {
    return {
      currentApiLang: 'en-US',
      routeName: this.$route.name,
    }
  },
  methods: {
    ...mapMutations(['changeLang']),
    setLang (lang) {
      setup(lang)
      this.changeLang(lang)
    },
  },
  watch: {
    '$store.state.apiLang': {
      immediate: true,
      handler (val) {
        this.currentApiLang = val
      },
    },
  },
}
</script>

<style lang="less" scoped>
@import url('../assets/less/var.less');

.footer {
  padding: 0 0 20px;
  text-align: left;
}

.footer-wrapper {
  background: #fff;
  width: @main-content-width;
  box-sizing: border-box;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.85);
  font-size: 12px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
  border-radius: 6px;

  a,
  a:hover {
    color: rgba(0, 0, 0, 0.85);
    text-decoration: none;
  }
}

.footer-main {
  padding: 0 30px 28px;
  display: flex;
  justify-content: space-between;
}

.footer-main--left {
  padding-top: 27px;
  & > div {
    margin-bottom: 18px;
  }
  & > div:last-of-type {
    margin-bottom: 0;
  }

  .brand-text {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.5);
  }

  .contact > span {
    margin-right: 17px;
  }

  .s-icon:hover {
    cursor: pointer;
    color: @theme-color;
  }
}

.footer-main--right {
  padding-top: 32px;

  .intro-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
  }

  & > div {
    margin-bottom: 14px;
  }
  & > div:last-of-type {
    margin-bottom: 0;
  }
}

.footer-bottom {
  padding: 20px 30px;
  border-top: 1px solid rgba(224, 224, 224, 0.5);
  display: flex;
  justify-content: space-between;
}

.footer-bottom--right {
  a {
    color: rgba(0, 0, 0, 0.5);
    text-decoration: none;
    padding: 0 10px;
    border-right: 1px solid #ccc;

    &.is-active {
      color: #99d20d;
    }
  }
  a:last-of-type {
    border-right: none;
  }
}

.logo {
  width: 68px;
  height: 50px;
  background: url('../assets/images/logo-color.png') center no-repeat;
  background-size: 100%;
}

@media (max-width: 767px) {
  .footer {
    padding: 0 12px 16px;
  }

  .footer-wrapper {
    width: 100%;
    border-radius: 4px;
    font-size: 12px;
  }

  .footer-main {
    display: block;
    padding: 22px 18px;
  }

  .footer-main--left {
    padding-top: 0;

    & > div {
      margin-bottom: 12px;
    }

    .brand-text {
      font-size: 15px;
    }

    .contact {
      display: flex;
      flex-wrap: wrap;
      gap: 10px 14px;
      line-height: 1.5;
    }

    .contact > span {
      margin-right: 0;
      max-width: 100%;
      overflow-wrap: break-word;
    }
  }

  .footer-main--right {
    padding-top: 22px;

    & > div {
      margin-bottom: 10px;
    }
  }

  .footer-bottom {
    display: block;
    padding: 16px 18px;
    line-height: 1.5;
  }

  .footer-bottom--left {
    margin-bottom: 12px;
  }

  .footer-bottom--right {
    a:first-of-type {
      padding-left: 0;
    }
  }
}
</style>
